import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import { getDate, getTodayDate } from "../../util";
import NumberInputField from "../../components/form/NumberInputField";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import PhoneInputField from "../../components/form/PhoneInputField";
import SelectField from "../../components/form/SelectField";

const ContractAward = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };
  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Contract Award</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col sm:px-10 "
      >
        <InputField
          register={register}
          name="contract_number"
          label="Contract Number"
          errors={errors.contract_number}
          type="text"
        />
        <div className="flex gap-10 sm:gap-20">
          <InputField
            register={register}
            name="date"
            label="Date"
            type="date"
            defaultValue={getTodayDate()}
            errors={errors.date}
          />
          <InputField
            register={register}
            name="award_date"
            label="Award Date"
            type="date"
            defaultValue={getTodayDate()}
            errors={errors.award_date}
          />
        </div>
        <div className="p-5 text-center">Vendor Information</div>
        <InputField
          register={register}
          name="vendor_name"
          label="Vendor Name"
          type="text"
          errors={errors.vendor_name}
        />
        <InputField
          register={register}
          name="address"
          label="Address"
          type="text"
          errors={errors.address}
        />
        <div className="sm:flex gap-10 sm:gap-20">
          <PhoneInputField
            register={register}
            name="phone"
            label="Phone"
            type="text"
            errors={errors.vendor_name}
          />
          <InputField
            register={register}
            name="email"
            label="Email"
            type="text"
            errors={errors.vendor_name}
          />
        </div>
        <div className="p-5 text-center">Contract Details</div>
        <div className="flex gap-10 sm:gap-20">
          <InputField
            register={register}
            name="contract_amount"
            label="Contract Amount"
            errors={errors.contract_amount}
            type="number"
          />
          <div className="flex-1" />
        </div>
        <div className="flex gap-10 sm:gap-20">
          <InputField
            register={register}
            name="payment_terms"
            label="Payment Terms"
            errors={errors.payment_terms}
            type="text"
          />
          <div className="flex-1" />
        </div>
        <div className="flex gap-10 sm:gap-20">
          <InputField
            register={register}
            name="contract_duration"
            label="Cotract Duration"
            errors={errors.contract_duration}
            type="text"
          />
          <div className="flex-1" />
        </div>
        <div className="flex gap-10 sm:gap-20">
          <InputField
            register={register}
            name="start_date"
            label="Start Date"
            type="date"
            defaultValue={getTodayDate()}
            errors={errors.start_date}
          />

          <InputField
            register={register}
            name="end_date"
            label="End Date"
            type="date"
            defaultValue={getTodayDate()}
            errors={errors.end_date}
          />
        </div>
        <div className="p-5 text-center">Approval Status</div>
        <SelectField
          register={register}
          name="status"
          label="Status"
          data={[
            { id: "", name: "-- Select Status" },
            { id: "", name: "Pending" },
            { id: "", name: "Approved" },
            { id: "", name: "Rejected" },
          ]}
          errors={errors.status}
        />
        <TextAreaField
          register={register}
          name="comments"
          label="Comments"
          errors={errors.comments}
        />

        <ResourseButtons link to="/accounts/maintenance" />
      </form>
    </MainContainer>
  );
};

export default ContractAward;
